export default __webpack_public_path__ + "static/media/placeholder.879b08b8.webp";